module.exports = "/_next/static/images/BuildHighPerformance-2@2x-b1ebc31c2243bb3bd91c9314115aff3c.png";